// @flow
import React from "react";
import {
  useAuth,
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocDataOnce,
} from "reactfire";
import AppHeader from "../components/AppHeader";
import Container from "@material-ui/core/Container";
import AdminEntry from "./Admin/AdminEntry";
import AdminAddGame from "./Admin/AdminAddGame";
import AdminAddLocation from "./Admin/AdminAddLocation";
import AdminAddOpponent from "./Admin/AdminAddOpponent";
import AdminAddTeam from "./Admin/AdminAddTeam";
import AdminEditGames from "./Admin/AdminEditGames";
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import PinDropRoundedIcon from '@material-ui/icons/PinDropRounded';
import SupervisedUserCircleRoundedIcon from '@material-ui/icons/SupervisedUserCircleRounded';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import Helmet from "react-helmet";

function Admin() {
  const auth = useAuth();
  const firestore = useFirestore();

  const user = auth.currentUser;
  const usersRef = firestore.collection("users");
  const userDataRef = usersRef.doc(user.uid);
  const userData = useFirestoreDocDataOnce(userDataRef);

  const gamesRef = firestore.collection("games");

  const games = useFirestoreCollectionData(gamesRef);
  const teams = useFirestoreCollectionData(firestore.collection("teams"));
  const opponents = useFirestoreCollectionData(
    firestore.collection("opponents")
  );
  const locations = useFirestoreCollectionData(
    firestore.collection("locations")
  );

  if (!userData.admin) {
    return <p>Keine Berechtigung</p>;
  }
  return (
    <>
      <Helmet>
        <title>Administration - SG Coesfeld 06</title>
      </Helmet>
      <AppHeader title="Administration" />
      <Container maxWidth="sm">
        <AdminEntry
          title="Spiel hinzufügen"
          id="addGame"
          icon={<AddCircleRoundedIcon color="action" />}
          form={
            <AdminAddGame
              teams={teams}
              opponents={opponents}
              locations={locations}
            />
          }
        />
        <AdminEntry
          title="Spiele bearbeiten"
          id="editGame"
          icon={<EditRoundedIcon color="action" />}
          form={
            <AdminEditGames
              games={games}
              teams={teams}
              opponents={opponents}
            />
          }
        />
        <AdminEntry
          title="Spielort hinzufügen"
          id="addLocation"
          icon={<PinDropRoundedIcon color="action" />}
          form={<AdminAddLocation />}
        />
        <AdminEntry
          title="Gegner hinzufügen"
          id="addOpponent"
          icon={<SupervisedUserCircleRoundedIcon color="action" />}
          form={<AdminAddOpponent />}
        />
        <AdminEntry
          title="Team hinzufügen"
          id="addTeam"
          icon={<AccountCircleRoundedIcon color="action" />}
          form={<AdminAddTeam />}
        />
        <div style={{height: 50}} />
      </Container>
      </>
  );
}

export default Admin;
